$(document).ready(function () {

    // http://stackoverflow.com/questions/28322636/synchronous-xmlhttprequest-warning-and-script
    $.ajaxPrefilter(function( options, originalOptions, jqXHR ) {
        options.async = true;
    });

    // Load information into detail page side bar once on desktop
    if($('#agent-photo-placeholder').is(':empty') && $(document).width() >= 992) {
        $('#IDX-nextLastButtons').clone().appendTo('#next-placeholder');
        $('#IDX-detailsAgentPhoto').clone().appendTo('#agent-photo-placeholder');
        $('#IDX-detailsFeaturedAgentdisplayname').clone().appendTo('#agent-text-placeholder');
        $('#IDX-detailsFeaturedAgenttitle').clone().appendTo('#agent-text-placeholder');
        $('#IDX-detailsHotActions').clone().appendTo('#actions-placeholder');
    }
    
    // Bootstrap carosel on home page
    $('.carousel').carousel({
      interval: 10000,
      keyboard: false
    });

    $(window).bind("load", function () {
        // Do not show markup for agent photo until we know it is present on desktop
        if(!$('#agent-photo-placeholder').is(':empty') && $(document).width() >= 992) {
            $('#agent-sidebar-display').show();
        }
    });   
});